module.exports = "query getReport($id:String){getReport(id:$id){id name description filters{title key type default options}fields{title key type}}}"